import { render, staticRenderFns } from "./ModalStatusHistory.vue?vue&type=template&id=d61d4c78&scoped=true&"
import script from "./ModalStatusHistory.vue?vue&type=script&lang=ts&"
export * from "./ModalStatusHistory.vue?vue&type=script&lang=ts&"
import style0 from "./ModalStatusHistory.vue?vue&type=style&index=0&id=d61d4c78&prod&lang=scss&"
import style1 from "./ModalStatusHistory.vue?vue&type=style&index=1&id=d61d4c78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61d4c78",
  null
  
)

export default component.exports